"use client";
import { AiOutlineSetting } from "@onemind-services-llc/react-icons-ng/ai";
import { MdOutlineIntegrationInstructions } from "@onemind-services-llc/react-icons-ng/md";
import { ContentWithLabelList, ContentCard } from "@/components/contentCard";

export const NETWORK_AUTOMATION_CONSTANTS = {
  title: "Network Automation Services ",
  desc: "For organizations seeking to implement network automation, specialized services are available to facilitate this transition. These services offer comprehensive solutions, including: ",
  list: [
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Ansible Instant Environment ",
      subTitle: "Fast-Track Your NetDevOps Journey",
      content: (
        <ContentCard
          text={
            "Step into the future of network automation with OneMind’s Ansible Instant Environment—a ready-to-use, cloud-hosted platform designed for rapid network provisioning and orchestration.\nWithin minutes, gain access to a powerful automation workspace pre-loaded with Ansible playbooks, roles, modules, and templates—tailored for network infrastructure as code. \nNo setup. No hardware. No hassle."
          }
          points={[
            "Spin up automation labs instantly.",
            "Customize workflows to fit your network stack.",
            " Experiment, learn, or deploy—your way.",
          ]}
        />
      ),
      conclusion:
        "Whether you're just starting with Net DevOps or scaling enterprise-wide automation, OneMind makes network automation accessible, secure, and scalable by design.",
    },
    {
      icon: AiOutlineSetting,
      title: "Professional Support",
      subTitle: "Expert Guidance, Seamless Execution",
      content: (
        <ContentWithLabelList
          text={
            "Accelerate your automation initiatives with OneMind’s Professional Support Services—delivered by experienced engineers who specialize in deploying and managing network automation solutions across complex environments. \nFrom initial design to full-scale rollout, we ensure your automation strategy aligns with business goals, integrates cleanly with existing systems, and delivers measurable results."
          }
          points={[
            {
              label: "Expert-Led Implementation",
              text: "Work side-by-side with certified automation professionals.",
            },
            {
              label: "Custom Integrations",
              text: "Tailor solutions to fit your infrastructure, toolsets, and workflows.",
            },
            {
              label: "Ongoing Optimization",
              text: "Get continuous guidance to refine, scale, and future-proof your automation stack.",
            },
          ]}
        />
      ),
      conclusion:
        "Whether you're starting fresh or scaling an existing framework, OneMind provides the knowledge, tools, and hands-on support to ensure your success—every step of the way.",
    },
  ],
  conclusion:
    "By leveraging these services, businesses can accelerate their automation initiatives, reduce operational complexities, and focus on strategic growth. ",
};
